import { Camera } from "lucide-react";
import { Reveal, SectionHead } from "./Reveal";
import { IMAGES, mediaUrl } from "../../lib/site";

const PLACEHOLDERS = [
  { src: IMAGES.hero, label: "Stage moments — photos coming soon" },
  { src: IMAGES.vinyl, label: "Group photographs — coming soon" },
  { src: IMAGES.hall, label: "Event photographs — coming soon" },
  { src: IMAGES.guitars, label: "Behind the scenes — coming soon" },
];

export default function Gallery({ gallery = [] }) {
  const items = gallery.length > 0 ? gallery : PLACEHOLDERS;
  const isPlaceholder = gallery.length === 0;
  return (
    <section id="gallery" className="bg-navy-900/50 py-20 lg:py-28" data-testid="gallery-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        <SectionHead
          eyebrow="Gallery"
          title="Moments & Memories"
          sub={isPlaceholder ? "Our photo library is being curated — authentic performance photographs will appear here soon." : "Glimpses from our performances and gatherings."}
        />
        <div className="mt-14 grid grid-cols-2 gap-4 lg:grid-cols-4">
          {items.map((g, i) => (
            <Reveal key={i} delay={0.06 * i} className={i % 3 === 0 ? "lg:row-span-2" : ""}>
              <figure className="group relative h-full overflow-hidden rounded-2xl border border-navy-700" data-testid={`gallery-item-${i}`}>
                <img
                  src={mediaUrl(g.src)}
                  alt={g.label || g.caption || "Tricity Kroonerz gallery image"}
                  loading="lazy"
                  className={`w-full object-cover transition-transform duration-700 group-hover:scale-105 ${i % 3 === 0 ? "h-64 lg:h-full" : "h-64"}`}
                />
                <figcaption className="absolute inset-x-0 bottom-0 flex items-center gap-2 bg-gradient-to-t from-navy-950/90 to-transparent px-4 pb-3 pt-10 text-xs font-semibold text-slate-300">
                  {isPlaceholder && <Camera className="h-3.5 w-3.5 text-gold" />}
                  {isPlaceholder ? `Placeholder · ${g.label}` : g.caption}
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
